const PlaceholderCompanyIcon = () => {
  return (
    <svg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='33' height='33' rx='4' fill='#D9D9D9' />
    </svg>
  );
};

export default PlaceholderCompanyIcon;
